<template>
  <div class="document">
    <div class="document_steps">
      <!-- <p>Step 1:</p> -->
      <!-- <div class="document_steps_btn">
        <div class="document_steps_btn_text">
          Click the button to see some documents you are to download, fill and
          upload back 
        </div>
        <div class="document_steps_btn_box">
          <div @click="download">Download Documents</div>
        </div>
      </div>-->
      <!-- <p>Step 2:</p> -->
      <div class="document_steps_progress">
        <span>Select the document in the dropdown and upload.</span>
        <p>
          PS: once you upload; it shows below in your uploaded document section
        </p>
        <div>
          <div>
            <div v-if="uploadBar">{{ loadingComplete }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="document_uploads">
      <div v-for="(val, index) in uploads" :key="index">
        <div class="document_uploads_name">
          <select v-model="val.selectedValue">
            <option value>Select a Document</option>
            <option value="academic"
              >Academic Certificate (WAEC, BSC et.al)</option
            >
            <option value="cv">CV</option>
          </select>
        </div>
        <div class="document_uploads_input" v-if="val.selectedValue">
          <div>
            <div class="document_uploads_input_file">
              <img
                class="logo"
                src="../../../../assets/images/file-recruit.svg"
                alt="file"
              />
            </div>
            <div class="document_uploads_input_text">
              Click to upload document
            </div>
            <input accept="image/*,.pdf,.xls,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" type="file" @change="selectDocument(val)" />
          </div>
        </div>
        <div class="document_uploads_text" v-if="val.uploadedFile">
          {{ val.uploadedFileName }}
        </div>
        <div class="document_uploads_check" v-if="val.response">
          <img
            class="logo"
            src="../../../../assets/images/checked.svg"
            alt="check"
          />
        </div>
      </div>
    </div>

    <div class="document_uploads_add">
      <div
        class="document_uploads_add_upload"
        v-if="!btnLoader"
        @click="addDocument"
      >
        + Click to add more documents for upload
      </div>
      <div class="document_uploads_add_save">
        <div v-if="!btnLoader" @click="sendDocument">Save & Proceed</div>
        <div v-if="btnLoader">
          <WhiteLoader />
        </div>
      </div>
    </div>

    <div class="document_table">
      <p>Your Uploaded Document(s):</p>
      <div v-if="!pageLoader">
        <div class="document_table_loader">
          <PageLoader />
        </div>
      </div>
      <div v-if="pageLoader">
        <div class="document_table_head">
          <div>Name</div>
          <div>Date Uploaded</div>
          <div>Action</div>
        </div>
        <div class="document_table_body">
          <div v-for="(val, index) in documents" :key="index" :value="val.id">
            <div>
              <p>
                <font-awesome-icon icon="file" />
                &nbsp;{{ val.title }}
              </p>
            </div>
            <div>{{ val.created_at.split(" ")[0] }}</div>
            <div>
              <span class="download">
                <a :href="`${val.url}`" target="_blank" download>
                  <font-awesome-icon icon="download" />
                </a> </span
              >&nbsp;
              <span class="delete">
                <font-awesome-icon icon="times" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../../store/constant";
import PageLoader from "../../../partials/page-loader";
import WhiteLoader from "../../../partials/white-loader";

export default {
  name: "Document",
  components: {
    WhiteLoader,
    PageLoader
  },
  data() {
    return {
      uploadBar: false,
      loadingComplete: "Uploading Files",
      btnLoader: false,
      pageLoader: false,
      s3URL: types.S3_BUCKET_URL,
      documents: [],
      uploads: [
        {
          ref:
            "id" +
            Math.random()
              .toString(16)
              .slice(2),
          selectedValue: "academic",
          uploadedFile: false,
          title: "",
          fileName: "",
          uploadedFileName: "",
          response: false,
          respMessage: ""
        },
        // {
        //   ref:
        //     "id" +
        //     Math.random()
        //       .toString(16)
        //       .slice(2),
        //   selectedValue: "cv",
        //   uploadedFile: false,
        //   title: "",
        //   fileName: "",
        //   uploadedFileName: "",
        //   response: false,
        //   respMessage: ""
        // }
      ]
    };
  },
  methods: {
    download() {
      var urls = [
        "documents/biodata.pdf",
        "documents/guarantor.pdf",
        "documents/hmo.pdf",
        "documents/hospital.pdf",
        "documents/pension.pdf",
        "documents/resumption.pdf"
      ];

      var interval = setInterval(download, 300, urls);

      function download(urls) {
        var url = urls.pop();

        var a = document.createElement("a");
        a.setAttribute("href", url);
        a.setAttribute("download", "");
        a.setAttribute("target", "_blank");
        a.click();

        if (urls.length == 0) {
          clearInterval(interval);
        }
      }
    },
    showSubmission() {
      this.$emit("clickedSubmission");
    },
    getDocuments() {
      this.$http.get(types.JOBSEEKER_DOCUMENT_UPLOAD).then(resp => {
        this.documents = [...resp.data.data];

        this.$store.state.jobseekerDocumentLength = this.documents.length;
        this.pageLoader = true;
      });
    },
    addDocument() {
      this.uploads.push({
        ref:
          "id" +
          Math.random()
            .toString(16)
            .slice(2),
        selectedValue: "",
        uploadedFile: false,
        file: "",
        fileName: "",
        uploadedFileName: "",
        response: false,
        respMessage: ""
      });
    },
    selectDocument(val) {
      if (event.target.files.length > 0) {
        val.uploadedFile = false;
        val.fileName = event.target.files[0].name;
        val.file = event.target.files[0];
        val.fileExt = val.fileName.split(".").pop();

        if (val.file) {
          val.uploadedFileName = val.fileName.split("\\").pop();
          val.uploadedFile = true;
        }
      } else {
        val.selectedValue = "";
        val.uploadedFileName = "";
        val.uploadedFile = false;
      }
    },
    sendDocument() {
      const docLoader = document.querySelector(
        ".document_steps_progress > div > div"
      );

      const selectedFiles = [];
      for (let index = 0; index < this.uploads.length; index++) {
        if (this.uploads[index].selectedValue) {
          selectedFiles.push(this.uploads[index]);
        }
      }

      const lastFile = selectedFiles[selectedFiles.length - 1].ref;

      for (let index = 0; index < this.uploads.length; index++) {
        if (this.uploads[index].selectedValue) {
          if (this.uploads[index].file.size < 500000) {
            this.btnLoader = true;
            docLoader.style.transition = "width 30s";
            docLoader.style.webkittransition = "width 30s";
            docLoader.style.width = "70%";

            let formData = new FormData();
            formData.append("file", this.uploads[index].file);
            formData.append("title", this.uploads[index].selectedValue);

            this.$http
              .post(types.JOBSEEKER_DOCUMENT_UPLOAD, formData)
              .then(resp => {
                this.uploads[index].response = true;
                this.uploads[index].respMessage = resp.data.data;

                if (this.uploads[index].ref === lastFile) {
                  this.uploadBar = true;
                  docLoader.style.transition = "width 5s";
                  docLoader.style.webkittransition = "width 5s";
                  docLoader.style.width = "100%";
                  this.getDocuments();
                  this.btnLoader = false;

                }
              })
              .catch(err => {
                this.uploads[index].response = false;
                this.uploads[index].respMessage = err.response.data.message;
                if (this.uploads[index].ref === lastFile) {
                  // docLoader.style.transition = "width 5s";
                  // docLoader.style.webkittransition = "width 5s";
                  // docLoader.style.width = "100%";
                  this.uploadBar = false;
                  this.btnLoader = false;
                  console.log("upload failed")
                  this.getDocuments();
                   location.reload();

                }
              });
          }
        }
      }
    },
    loadDocuments() {
      this.pageLoader = false;

      this.$http
        .get(types.JOBSEEKER_DOCUMENT_UPLOAD)
        .then(resp => {
          this.documents = [...resp.data.data];

          this.$store.state.jobseekerDocumentLength = this.documents.length;

          this.btnLoader = false;
          this.pageLoader = true;

          this.showSubmission();
        })
        .catch(err => {
          this.btnLoader = false;
          this.pageLoader = true;
        });
    }
  },
  created() {
    this.getDocuments();
  }
};
</script>

<style lang="scss" scoped>
.document {
  border-radius: 2px;
  padding: 50px;

  @media (max-width: 700px) {
    padding: 30px 10px;
  }

  > .document_steps {
    > p {
      font-size: 16px;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      line-height: 1;
      letter-spacing: normal;
      text-align: left;
      color: #000000;
      margin: 0;
    }

    > .document_steps_btn {
      border-radius: 5px;
      box-shadow: 0 2px 4px 0 #fff9f0;
      border: solid 2px #ffe7bd;
      background-color: #fff9f0;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
      align-content: center;
      padding: 20px;
      margin: 20px 0;

      > .document_steps_btn_text {
        width: 70%;
        padding: 10px;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.19;
        letter-spacing: normal;
        text-align: left;
        color: #000000;

        @media (max-width: 700px) {
          width: 100%;
        }
      }

      > .document_steps_btn_box {
        width: 30%;

        @media (max-width: 700px) {
          width: 100%;
        }

        > div {
          border-radius: 5px;
          background-color: #f79320;
          font-size: 13px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.21;
          letter-spacing: normal;
          text-align: center;
          color: #ffffff;
          width: 90%;
          max-width: 150px;
          margin: auto;
          padding: 10px 0;
          cursor: pointer;
        }
      }
    }

    > .document_steps_progress {
      margin: 20px;

      > span {
        font-size: 16px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: 2;
        letter-spacing: normal;
        text-align: left;
        color: #f79320;
      }

      > p {
        font-size: 14px;
        font-weight: 200;
        font-stretch: normal;
        font-style: normal;
        line-height: 2;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
      }

      > div {
        position: relative;
        height: 50px;

        > div {
          width: 0%;
          height: 25px;
          position: absolute;
          left: 0;
          border-radius: 20px;
          background-color: #c7c7c7;
          font-size: 12px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          line-height: 2;
          letter-spacing: normal;
          text-align: center;
          color: #000000;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          justify-content: center;
          align-content: center;
          overflow: hidden;
        }
      }
    }
  }

  > .document_uploads {
    padding: 0 20px;
    > div {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-content: center;
      align-items: center;
      margin-bottom: 50px;

      > .document_uploads_name {
        width: 200px;
        border: solid 1px #707070;
        height: 60px;
        margin-bottom: 10px;

        > select {
          height: 60px;
          border: none;
          outline: 0;
          padding: 0 5px;
          background-color: transparent;
        }
      }

      > .document_uploads_input {
        width: calc(100% - 550px);
        min-width: 300px;
        margin-bottom: 10px;

        > div {
          width: 90%;
          max-width: 500px;
          min-height: 80px;
          margin: auto;
          border: dashed 1px #5099de;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          justify-content: center;
          align-content: center;
          align-items: center;
          position: relative;

          @media (max-width: 500px) {
            width: 100%;
          }

          > input {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            cursor: pointer;
            opacity: 0;
          }

          > .document_uploads_input_file {
            width: 100px;
            text-align: center;

            > img {
              width: 30px;
            }
          }

          > .document_uploads_input_text {
            width: calc(100% - 100px);
            font-size: 16px;
            font-weight: 200;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.5;
            letter-spacing: normal;
            text-align: center;
            color: #5099de;
          }
        }
      }

      > .document_uploads_text {
        width: 300px;
        padding: 10px;
        font-size: 13px;
        font-weight: 200;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.33;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
        margin-bottom: 10px;
      }

      > .document_uploads_check {
        width: 50px;
        margin-bottom: 10px;

        > img {
          width: 20px;
        }
      }
    }
  }

  > .document_uploads_add {
    padding: 0 20px;

    > .document_uploads_add_upload {
      border: dashed 1px #c7c7c7;
      padding: 20px 0;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 2;
      letter-spacing: normal;
      text-align: center;
      color: #777777;
      cursor: pointer;
    }

    > .document_uploads_add_save {
      margin: 30px 0;
      > div {
        width: 200px;
        height: 40px;
        margin: auto;
        border-radius: 5px;
        background-color: #5099de;
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.21;
        letter-spacing: normal;
        text-align: center;
        color: #ffffff;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: center;
        align-content: center;
        align-items: center;
        cursor: pointer;
      }
    }
  }

  > .document_table {
    > p {
      font-size: 16px;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.67;
      letter-spacing: normal;
      text-align: left;
      color: #000000;
    }

    > div {
      > .document_table_loader {
        width: 55px;
        margin: auto;
      }

      > .document_table_head {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: center;
        align-content: center;
        border-bottom: 5px solid #5099de;

        > div {
          width: 33.3333333%;
          padding: 12px 0;
          text-align: center;
          font-size: 14px;
          font-weight: 600;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.19;
          letter-spacing: normal;
          color: #000000;
        }
      }

      > .document_table_body {
        > div {
          padding: 10px 0;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          justify-content: center;
          align-content: center;
          border-radius: 2px;
          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
          background-color: #ffffff;
          margin-bottom: 30px;
          > div {
            width: 33.3333333%;
            padding: 12px 0;
            text-align: center;
            font-size: 14px;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.19;
            letter-spacing: normal;
            color: #000000;

            > p {
              color: #5099de;
              cursor: pointer;
              margin: 0;
            }

            > span {
              cursor: pointer;

              > a {
                color: #5099de;
                text-decoration: none;
              }
            }

            > .delete {
              color: #f3826c;
            }
          }
        }
      }
    }
  }
}
</style>
